var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-pbx__byoc",attrs:{"data-testid":"checkout-div-170"},domProps:{"innerHTML":_vm._s(_vm.$t('billing.pbx.bring_your_own_carrier', [_vm.contactSalesLink]))},on:{"click":_vm.onContactSalesClick}})}
var staticRenderFns = []

export { render, staticRenderFns }